import React from "react";
import "./Banner.css";

const Banner = ({ image, alt, title, subtitle,   titleColor = "#ffffff", subtitleColor = "#ffffff" }) => (
  <div className="banner">
    <img src={image} alt={alt} className="banner-image" />
    <div className="banner-content">
    <h1 style={{ color: titleColor }}>{title}</h1>
    <p style={{ color: subtitleColor }}>{subtitle}</p>
    </div>
  </div>
);

export default Banner;
